import React from "react";
import { LaunchpadType, useLaunchpadConfig } from "components/launchpad/useLaunchpadConfig";
import { DefaultLaunchpadBannerContent } from "./DefaultLaunchpadBannerContent";
import { BookkeepersLaunchPadBannerContent } from "./BookkeepersLaunchPadBannerContent";
import { BrexLaunchpadBannerContent } from "./BrexLaunchPadBannerContent";

export const LaunchpadBannerLeftSectionContent = () => {
  const { type } = useLaunchpadConfig();

  if (type === LaunchpadType.Brex) {
    return <BrexLaunchpadBannerContent />;
  } else if (type === LaunchpadType.Bookkeepers) {
    return <BookkeepersLaunchPadBannerContent />;
  }

  return <DefaultLaunchpadBannerContent />;
};
